module.exports = __webpack_public_path__ + "308594be6e030f35d09f213f10cd352c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/low_130.jpg
// module id = 1730
// module chunks = 5